import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, Spinner } from 'react-bootstrap';
import notifier from '../../../_utils/notifier';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { renderField } from '../common/FormsControls.jsx';
import TinyContentInfoBlock from '../common/TinyContentInfoBlock.jsx';
import { ThreeDots } from '../common/Placeholders.jsx';
import { getUserData, updateUserData } from '../../actions/user';


const DeleteSubscription = ({ userSlug, paypal_subscription_id, getUserData,
                              handleSubmit, submitting, anyTouched }) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getUserData(userSlug).then(() => setIsLoading(false));
  }, []);

  if (isLoading) return <ThreeDots/>;
  if (paypal_subscription_id){
    return(<div>
      <TinyContentInfoBlock name='users_delete_subscription' without_spoiler={ true } />
      <Form onSubmit={ handleSubmit } className={ '' + (anyTouched ? ' was-validate' : '') }>
        <Field label={ gettext('Причина отмены подписки') }
               component={ renderField }
               element='textarea'
               name='subscription_cancel_reason'/>
        <Field component={renderField} type="hidden" name='paypal_subscription_id'/>

        <div className='text-lg-right mt-3'>
          <Button variant="primary" type="submit" disabled={ submitting }
                  className='mt-2 mt-md-0'>
            { submitting
              ? <>
                  <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className='mr-1'/>
                  { gettext('Отправляется') + '...' }
                </>
              : gettext('Отменить подписку') }
          </Button>
        </div>
      </Form>
    </div>);
  } else {
    return <TinyContentInfoBlock name='users_delete_subscription_success' without_spoiler={ true } />
  }
}

DeleteSubscription.PropTypes = {
  userSlug: PropTypes.string.isRequired,
  paypal_subscription_id: PropTypes.string,
  getUserData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  anyTouched: PropTypes.bool.isRequired,
}

let mapStateToProps = (state) => {
  return {
    userSlug: state.auth.slug,
    paypal_subscription_id: state.user.paypal_subscription_id,
    initialValues: { paypal_subscription_id: '' }
  }
};

export default compose(
  connect(mapStateToProps, { getUserData, onSubmit: updateUserData }),
  LoginRequired,
  Page,
  reduxForm({ form:'deleteSubscriptionForm' }),
)(DeleteSubscription);

